/** @jsxImportSource @emotion/react */

import React from 'react';
import { breakpoints } from '../../../global/global-config';
import { NavigationBrandBar as SherpaNavigationBrandBar } from '../../../../deps/@bshgroup/component-navigation';
import { CSSProp } from '../../../types/emotion';

export interface BrandlineProps {
  /**
   * image component to be used instead of the default 'img' tag
   */
  imageComponent?: any;
}

export function Brandline({
  imageComponent,
  ...props
}: BrandlineProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof BrandlineProps> & CSSProp) {
  const ImageComponent = imageComponent || 'img';

  return (
    <SherpaNavigationBrandBar
      size={{
        [breakpoints.sm]: 'sm',
        [breakpoints.lg]: 'lg',
      }}
      src="/assets/images/brandline.png"
      as={ImageComponent}
      {...props}
    />
  );
}
